// Build-time app version, generated into app-version.json by
// scripts/generate-version.js (run via the postinstall/prebuild/predev npm
// hooks). Used as the Bugsnag appVersion on both client and server, and by the
// source-map uploader, so a deploy's errors map to its uploaded source maps.
import versionInfo from "@/app-version.json";

export const APP_VERSION: string = versionInfo.version || "0.0.0-dev";
